<template>
  <l-layout layout="xs12 sm8 md6">
    <v-card>
      <v-card-title>
        <span class="title">批量导入合作用户</span>
      </v-card-title>
      <v-card-text style="height: 300px">
        <l-select-file select-type="dialog">
          <v-btn slot="activator">选择文件</v-btn>
        </l-select-file>
      </v-card-text>
    </v-card>
  </l-layout>
</template>

<script>
export default {
  name: 'newExport',
}
</script>

<style scoped>

</style>
